import React from 'react';
import API from '@aws-amplify/api';
import { useEffect, useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import InvoiceDashboard from './invoiceDashboard';
import Box from '@mui/material/Box';

import Grid from '../shared/Grid';
// TODO SHIP-754
// import LabeledSelect from '../shared/LabeledSelect';
import StatementStatus from '../shared/StatementStatus';
import { ProtectedRouteContext } from '../Context';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ApplicationHeader, BiColorHeader, MuiSelect as TermSelect } from './scholarshipApplication/components';
import RenderIf from '../renderIf/RenderIf';
import View from '../shared/View';

import './Finances.scss';

function Finances(props) {
    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const history = useHistory();
    const [doingAjax, setDoingAjax] = useState(true);
    const [initialized, setInitialized] = useState(false);

    // TODO SHIP-754
    // const [statements, setStatements] = useState();
    const [data, setData] = useState();
    const [selectedView, setSelectedView] = React.useState(props.location?.state?.tabConfig?.defaultView || 'invoices');
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedTerm, setSelectedTerm] = React.useState('');

    const invoiceStateRef = React.useRef();

    const headers = useMemo(() => {
        let _headers = [
            {
                //Column 1
                colName: 'studentName',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderStudent'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['studentName'].localeCompare(b['studentName']);
                        };
                    } else {
                        return (a, b) => {
                            return b['studentName'].localeCompare(a['studentName']);
                        };
                    }
                },
            },
            {
                //Column 2
                colName: 'grade',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderGrade'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['grade'] - b['grade'];
                        };
                    } else {
                        return (a, b) => {
                            return b['grade'] - a['grade'];
                        };
                    }
                },
            },
            {
                //Column 3
                colName: 'type',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderApplicationType'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['type'] - b['type'];
                        };
                    } else {
                        return (a, b) => {
                            return b['type'] - a['type'];
                        };
                    }
                },
            },
            {
                //Column 4
                colName: 'total',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderTotalAmt'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['total'] - b['total'];
                        };
                    } else {
                        return (a, b) => {
                            return b['total'] - a['total'];
                        };
                    }
                },
            },
            {
                //Column 5
                colName: 'tuition',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderTuition'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['tuition'] - b['tuition'];
                        };
                    } else {
                        return (a, b) => {
                            return b['tuition'] - a['tuition'];
                        };
                    }
                },
            },
            {
                //Column 6
                colName: 'fees',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderFees'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['fees'] - b['fees'];
                        };
                    } else {
                        return (a, b) => {
                            return b['fees'] - a['fees'];
                        };
                    }
                },
            },
            {
                //Column 7
                colName: 'discount',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderDiscount'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['discount'] - b['discount'];
                        };
                    } else {
                        return (a, b) => {
                            return b['discount'] - a['discount'];
                        };
                    }
                },
            },
            {
                //Column 8
                colName: 'submitted',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderSubmitted'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['submitted'] - b['submitted'];
                        };
                    } else {
                        return (a, b) => {
                            return b['submitted'] - a['submitted'];
                        };
                    }
                },
            },
            {
                //Column 9
                colName: 'status',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderStatus'),
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['status'] - b['status'];
                        };
                    } else {
                        return (a, b) => {
                            return b['status'] - a['status'];
                        };
                    }
                },
            },
        ];

        if (userSettings.UserType === 3) {
            _headers.splice(3, 0, {
                colName: 'schoolName',
                colLabel: t('Finances.AnnualStatementsTab.GridHeaderSchoolName'),
                filterOn: true,
                sortFunc: (dir) => {
                    if (!dir) {
                        return (a, b) => {
                            return a['schoolName'].localeCompare(b['schoolName']);
                        };
                    } else {
                        return (a, b) => {
                            return b['schoolName'].localeCompare(a['schoolName']);
                        };
                    }
                },
            });
        }

        return _headers;
    }, [t, userSettings]);

    const createColumns = (response) => {
        return response?.statements?.length > 0 && typeof response?.statements?.map === 'function'
            ? {
                  rows: response.statements.map((statement) => {
                      let _linkText = '',
                          _navAction;
                      switch (statement.StatementStatusID) {
                          case 1:
                              _linkText = userSettings.UserType === 2 ? 'Create' : '';
                              _navAction =
                                  userSettings.UserType === 2
                                      ? async () => {
                                            try {
                                                setDoingAjax(true);

                                                await API.post('ShipyardAPI', '/finances/annual_statement', {
                                                    body: {
                                                        applicationId: statement.AppInstID,
                                                        schoolId: statement.SchoolID,
                                                    },
                                                });

                                                history.push(`/finances/annualStatement/${statement.AppInstID}`, statement);
                                            } catch (error) {
                                                toast.error(t('General.AjaxError'));

                                                setDoingAjax(false);
                                            }
                                        }
                                      : null;
                              break;
                          case 2:
                              _linkText = userSettings.UserType === 2 ? 'Edit' : '';
                              _navAction =
                                  userSettings.UserType === 2
                                      ? () => {
                                            history.push(`/finances/annualStatement/${statement.AppInstID}`, statement);
                                        }
                                      : null;
                              break;
                          default:
                              _linkText = userSettings.UserType === 2 ? 'View' : 'Edit';
                              _navAction = () => {
                                  history.push(`/finances/annualStatement/${statement.AppInstID}`, statement);
                              };
                              break;
                      }

                      let _columns = [
                          <span colname="studentName">{`${statement.FirstName} ${statement.LastName}`}</span>,
                          <span colname="grade">{statement.GradeLevel}</span>,
                          <span colname="type">{statement.ApplicationType}</span>,
                          <span
                              colname="total"
                              className="positive"
                          >
                              {parseFloat(statement.Tuition + statement.Fees + statement.Discounts).toFixed(2)}
                          </span>,
                          <span
                              colname="tuition"
                              className="positive"
                          >
                              {typeof statement?.Tuition?.toFixed === 'function' ? statement.Tuition.toFixed(2) : '0.00'}
                          </span>,
                          <span
                              colname="fees"
                              className="positive"
                          >
                              {typeof statement?.Fees?.toFixed === 'function' ? statement.Fees.toFixed(2) : '0.00'}
                          </span>,
                          <span
                              colname="discount"
                              className="negative"
                          >
                              {typeof statement?.Discounts?.toFixed === 'function' ? statement.Discounts.toFixed(2) : '0.00'}
                          </span>,
                          <span colname="submitted">
                              {!!statement.SubmittedUTC ? new Date(statement.SubmittedUTC).toLocaleDateString() : '--/--/----'}
                          </span>,
                          <span colname="status">
                              <StatementStatus status={statement.StatementStatusID} />
                              &nbsp;{_linkText !== '' ? '/' : null}&nbsp;
                              <button
                                  className="button-link"
                                  onClick={_navAction}
                              >
                                  {_linkText}
                              </button>
                          </span>,
                      ];

                      if (userSettings.UserType === 3) {
                          _columns.splice(
                              3,
                              0,
                              <span colname="schoolName">
                                  {typeof statement?.SchoolName === 'string' ? statement.SchoolName : 'No School'}
                              </span>
                          );
                      }

                      return {
                          term: statement.AppTermID,
                          termDescription: statement.Description,
                          studentName: `${statement.FirstName} ${statement.LastName}`,
                          grade: statement.GradeLevelID,
                          schoolName: statement.SchoolName,
                          total: statement.Tuition + statement.Fees + statement.Discounts,
                          tuition: statement.Tuition,
                          fees: statement.Fees,
                          discount: statement.Discounts,
                          submitted: new Date(statement.SubmittedUTC),
                          status: statement.StatementStatusID,
                          columns: _columns,
                          type: statement.ApplicationTypeID,
                      };
                  }),
              }
            : undefined;
    };

    useEffect(() => {
        if (!initialized) {
            (async () => {
                try {
                    let financeState = JSON.parse(window.sessionStorage.getItem('financeState'));
                    let { currentTermID } = Number.isInteger(financeState?.currentTermID)
                        ? financeState
                        : await API.get('ShipyardAPI', '/applications/application_term');
                    setSelectedTerm(currentTermID);

                    let [response, { Terms }] = await Promise.all([
                        API.post('ShipyardAPI', '/finances', {
                            body: {
                                termId: currentTermID,
                            },
                        }),
                        financeState?.Terms?.length > 0 ? financeState : API.get('ShipyardAPI', '/applications/terms'),
                    ]);

                    setSelectOptions(Terms);

                    setData(createColumns(response));

                    setInitialized(true);
                    setDoingAjax(false);
                } catch (e) {
                    toast.error(t('General.AjaxError'));

                    setDoingAjax(false);
                }
            })();
        }
    }, [initialized, history, t, userSettings]);

    useEffect(
        () => () => {
            //This will only run when the component unmounts.
            window.sessionStorage.setItem(
                'financeState',
                JSON.stringify({
                    currentTermID: selectedTerm,
                    Terms: selectOptions,
                })
            );
        },
        [selectedTerm, selectOptions]
    );

    const a11yProps = () => {
        return {
            id: `finance-view-tab-${selectedView}`,
            'aria-controls': `finance-view-tabpanel-${selectedView}`,
        };
    };

    const handleAnnualStatementsChange = async (newTerm) => {
        let id =
            selectedView === 'annual'
                ? toast.loading(
                      `Retrieving annual statements for the ${selectOptions.find((opt) => opt.value === newTerm).label} School Year...`
                  )
                : -1;
        try {
            let response = await API.post('ShipyardAPI', '/finances', {
                body: {
                    termId: newTerm,
                },
            });
            setData(createColumns(response));
        } catch (e) {
            if (id !== -1) toast.error('General.AjaxError');
        } finally {
            if (id !== -1) toast.dismiss(id);
        }
    };

    return (
        <Box sx={{ padding: '16px', minHeight: '400px' }}>
            <ApplicationHeader
                headerTitle={
                    <BiColorHeader
                        left="My "
                        right="Finances."
                    />
                }
                headerRightComponent={
                    <TermSelect
                        options={selectOptions}
                        label="School Year"
                        handleChange={(e) => {
                            handleAnnualStatementsChange(e.target.value);
                            setSelectedTerm(e.target.value);
                        }}
                        value={selectedTerm}
                    />
                }
            />
            <Tabs
                value={selectedView}
                onChange={(e, val) => setSelectedView(val)}
                aria-label="basic tabs example"
            >
                <Tab
                    label="Invoices"
                    value="invoices"
                    {...a11yProps()}
                />
                <Tab
                    label="Annual Statements"
                    value="annual"
                    {...a11yProps()}
                />
            </Tabs>
            <RenderIf isTrue={selectedView === 'invoices' && selectedTerm !== ''}>
                <InvoiceDashboard
                    appTermId={selectedTerm}
                    stateRef={invoiceStateRef}
                />
            </RenderIf>
            <RenderIf isTrue={selectedView === 'annual'}>
                <View
                    doingAjax={doingAjax}
                    className="finances-view"
                    name="finances"
                >
                    {!!data ? (
                        <Grid
                            name="annual-statements-grid"
                            className="annual-statements-grid"
                            headers={headers}
                            data={data}
                            filters={userSettings.UserType === 3 ? true : false}
                            initialSort={userSettings.UserType === 3 ? 'schoolName' : 'studentName'}
                            pageSize={100}
                            search={true}
                            hoverable={true}
                        />
                    ) : !initialized ? (
                        <div className="no-statements">{t('Finances.AnnualStatementsTab.RetrievingStatements')}</div>
                    ) : (
                        <div className="no-statements">{t('Finances.AnnualStatementsTab.NoStatements')}</div>
                    )}
                </View>
            </RenderIf>
        </Box>
    );
}

export default Finances;
